import React, { useRef } from 'react';
import './FeaturedCarousel.css';

interface Item {
  id: string;
  name: string;
  images: string[];
  price?: string;
}

const FeaturedCarousel: React.FC<{ items: Item[] }> = ({ items }) => {
  const trackRef = useRef<HTMLDivElement | null>(null);

  const scrollBy = (direction: 'left' | 'right') => {
    const el = trackRef.current;
    if (!el) return;
    const amount = Math.round(el.clientWidth * 0.8);
    el.scrollBy({ left: direction === 'right' ? amount : -amount, behavior: 'smooth' });
  };

  return (
    <section className="featured-carousel">
      <button className="fc-btn prev" aria-label="Previous" onClick={() => scrollBy('left')}>‹</button>

      <div className="fc-track" ref={trackRef} tabIndex={0} aria-live="polite">
        {items && items.length > 0 ? (
          items.map((it) => (
            <article className="fc-item" key={it.id}>
              <div className="fc-image">
                <img src={it.images?.[0] || '/images/placeholder.jpg'} alt={it.name} loading="lazy" />
              </div>
              <div className="fc-meta">
                <div className="fc-name">{it.name}</div>
                {it.price && <div className="fc-price">{it.price}</div>}
              </div>
            </article>
          ))
        ) : (
          <div className="fc-empty">No featured items</div>
        )}
      </div>

      <button className="fc-btn next" aria-label="Next" onClick={() => scrollBy('right')}>›</button>
    </section>
  );
};

export default FeaturedCarousel;
